// extracted by mini-css-extract-plugin
module.exports = {"page":"OversiktPage_page__YtKBx","content":"OversiktPage_content__gaHTQ","pictogram":"OversiktPage_pictogram__oCxK3"};